/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ConnectedApplication,
    ConnectedApplicationFromJSON,
    ConnectedApplicationFromJSONTyped,
    ConnectedApplicationToJSON,
} from './ConnectedApplication';
import {
    QueryInfo,
    QueryInfoFromJSON,
    QueryInfoFromJSONTyped,
    QueryInfoToJSON,
} from './QueryInfo';

/**
 * 
 * @export
 * @interface WorkspaceConnectedApplicationsResponse
 */
export interface WorkspaceConnectedApplicationsResponse {
    /**
     * 
     * @type {Array<ConnectedApplication>}
     * @memberof WorkspaceConnectedApplicationsResponse
     */
    results: Array<ConnectedApplication>;
    /**
     * 
     * @type {QueryInfo}
     * @memberof WorkspaceConnectedApplicationsResponse
     */
    listResult: QueryInfo;
    /**
     * Pagination token used in retrieving another page of items
     * @type {string}
     * @memberof WorkspaceConnectedApplicationsResponse
     */
    paginationToken?: string;
    /**
     * Whether there are more items in the next page
     * @type {boolean}
     * @memberof WorkspaceConnectedApplicationsResponse
     */
    hasNextPage?: boolean;
    /**
     * Whether there are more items in the previous page
     * @type {boolean}
     * @memberof WorkspaceConnectedApplicationsResponse
     */
    hasPreviousPage?: boolean;
}

export function WorkspaceConnectedApplicationsResponseFromJSON(json: any): WorkspaceConnectedApplicationsResponse {
    return WorkspaceConnectedApplicationsResponseFromJSONTyped(json, false);
}

export function WorkspaceConnectedApplicationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceConnectedApplicationsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(ConnectedApplicationFromJSON)),
        'listResult': QueryInfoFromJSON(json['listResult']),
        'paginationToken': !exists(json, 'paginationToken') ? undefined : json['paginationToken'],
        'hasNextPage': !exists(json, 'hasNextPage') ? undefined : json['hasNextPage'],
        'hasPreviousPage': !exists(json, 'hasPreviousPage') ? undefined : json['hasPreviousPage'],
    };
}

export function WorkspaceConnectedApplicationsResponseToJSON(value?: WorkspaceConnectedApplicationsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': ((value.results as Array<any>).map(ConnectedApplicationToJSON)),
        'listResult': QueryInfoToJSON(value.listResult),
        'paginationToken': value.paginationToken,
        'hasNextPage': value.hasNextPage,
        'hasPreviousPage': value.hasPreviousPage,
    };
}

